var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('NavBarTop'),_c('NavBarLeft'),_c('v-content',{attrs:{"fluid":""}},[_c('Map')],1),_c('events'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }